const Downloadlist = [

{
    title: 'Giving USA Special Report - Donor Confidence & Giving Behavior.pdf',
    fileName: 'Giving USA Special Report - Donor Confidence & Giving Behavior.pdf',
    fileUrl: 'https://gusa-bucket.s3.us-east-1.amazonaws.com/Giving+USA+Special+Report+-+Donor+Confidence+%26+Giving+Behavior.pdf',
},
{
    title: 'Giving USA Special Report Impact Giving 2026 Download',
    fileName: 'Giving_USA_Special_Report_Impact Giving_2026_Download',
    fileUrl: 'https://gusa-bucket.s3.us-east-1.amazonaws.com/Giving_USA_Special_Report_Impact+Giving_2026_Download.pdf',
},
{
    title: 'Giving USA Special Report - Generations and Giving',
    fileName: 'Giving_USA_Special_Report_Generations_and_Giving_2025_Download.pdf',
    fileUrl: 'https://gusa-bucket.s3.us-east-1.amazonaws.com/Giving_USA_Special_Report_Generations_and_Giving_2025_Download.pdf',
},
{
    title: 'Giving USA 2025 - 70-Year Total Giving Data Package',
    fileName: '2025_70-year_Total_Giving_Data_Package.zip',
    fileUrl: 'https://gusa-bucket.s3.us-east-1.amazonaws.com/2025_70-year_Total_Giving_Data_Package.zip',
},
{
    title: 'Giving USA 2025 - Annual Report',
    fileName: 'GUSA_2025_Annual_Report_Full_Digital_Book_Download.pdf',
    fileUrl: 'https://gusa-bucket.s3.us-east-1.amazonaws.com/GUSA_2025_Annual_Report_Full_Digital_Book_Download.pdf',
},
{
    title: 'Giving USA 2025 - Key Findings',
    fileName: 'Giving_USA_2025_Key_Findings_2025-07-08_v5.pdf',
    fileUrl: 'https://gusa-bucket.s3.us-east-1.amazonaws.com/Giving_USA_2025_Key_Findings_2025-07-08_v5.pdf',
  },
  {
    title: 'Giving USA 2025 - Comprehensive PowerPoint',
    fileName: 'Giving_USA_2025_Comprehensive_PowerPoint_2025-06-24.pptx',
    fileUrl: 'https://gusa-bucket.s3.us-east-1.amazonaws.com/Giving_USA_2025_Comprehensive_PowerPoint_2025-06-24.pptx',
  },
  {
    title: 'Giving USA 2025 - Data Tables',
    fileName: 'Giving_USA_2025_Data_Tables_2025-06-24.pdf',
    fileUrl: 'https://gusa-bucket.s3.us-east-1.amazonaws.com/Giving_USA_2025_Data_Tables_2025-06-24.pdf',
  },
  {
    title: 'Giving USA 2025 - Infographic',
    fileName: 'Giving_USA_2025_Infographic_2024-06-24.pdf',
    fileUrl: 'https://gusa-bucket.s3.us-east-1.amazonaws.com/Giving_USA_2025_Infographic_2024-06-24.pdf',
  },
{
    title: 'Giving USA Special Report - Giving by Generation UPDATE',
    fileName: 'Giving+By+Generation+2025+Digital.pdf',
    fileUrl: 'https://gusa-bucket.s3.us-east-1.amazonaws.com/Giving+By+Generation+2025+Digital.pdf',
  },
{
    title: 'Giving USA 2024 - Annual Report',
    fileName: 'Giving_USA_2024_Annual_Report_2024-08-06.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving_USA_2024_Annual_Report_2024-08-06.pdf',
  },
  {
    title: 'Giving USA 2024 - Comprehensive PowerPoint',
    fileName: 'Giving_USA_2024_Comprehensive_PowerPoint_2024-06-25.pptx',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving_USA_2024_Comprehensive_PowerPoint_2024-06-25.pptx',
  },
  {
    title: 'Giving USA 2024 - Data Tables',
    fileName: 'Giving_USA_2024_Data_Tables_2024-06-25.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving_USA_2024_Data_Tables_2024-06-25.pdf',
  },
  {
    title: 'Giving USA 2024 - Infographic',
    fileName: 'Giving_USA_2024_Infographic_2024-06-25.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving_USA_2024_Infographic_2024-06-25.pdf',
  },
  {
    title: 'Giving USA 2024 Annual Survey on State Laws',
    fileName: 'GUSA_2024+State+Laws+Report.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA_2024+State+Laws+Report.pdf',
  },
  {
    title: 'Giving USA 2024 - Key Findings',
    fileName: 'Giving_USA_2024_Key_Findings_2024-07-16.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving_USA_2024_Key_Findings_2024-07-16.pdf',
  },
  {
    title: 'American Jewish Philanthropy 2022: Giving to Religious and Secular Causes in the U.S. and to Israel',
    fileName: 'IU_AJP_report_2022_010224.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/IU_AJP_report_2022_010224.pdf',
  },  
  {
    title: 'Giving USA 2023 - Full Report PDF',
    fileName: 'GUSA2023_Digital_Final2023-07-13.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA2023_Digital_Final2023-07-13.pdf',
  },
  {
    title: 'Giving USA 2023 - Comprehensive PowerPoint',
    fileName: 'GivingUSA_2023_Comprehensive+PowerPoint_Final_GUSA2023_6.28.23.pptx',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Comprehensive+PowerPoint_Final_GUSA2023_6.28.23.pptx',
  },
  {
    title: 'Giving USA 2023 - Data Tables',
    fileName: 'GivingUSA_2023_Data_Tables_Download_v2.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GivingUSA_2023_Data_Tables_Download_v2.pdf',
  },
  {
    title: 'Giving USA 2023 - Infographic',
    fileName: 'GivingUSA_2023_Infographic_Download.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GivingUSA_2023_Infographic_Download.pdf',
  },
  {
    title: 'Giving USA 2023 - Key Findings',
    fileName: 'GivingUSA_2023_KeyFindings_Download.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA+2023+KeyFindings+Product_2023-06-29.pdf',
  },
  {
    title: 'Giving USA 2023 Annual Survey on State Laws',
    fileName: 'Giving USA 2023 Annual Survey on State Laws.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving+USA+2023+Annual+Survey+on+State+Laws.pdf',
  },
  {
    title: 'Giving USA Special Report - Giving by Generation',
    fileName: 'GUSA_Special_Report_Giving_by_Generation_Digital_Updated.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA_Special_Report_Giving_by_Generation_Digital_Updated.pdf',
  },
  {
    title: 'Giving USA 2022 - Full Report PDF',
    fileName: 'GUSA2022_Digital_Final2022-07-12.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA2022_Digital_Final2022-07-12.pdf',
  },
  {
    title: 'Giving USA 2022 - Comprehensive PowerPoint',
    fileName: 'GivingUSA2022_Comprehensive_PowerPoint.pptx',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GivingUSA2022_Comprehensive_PowerPoint.pptx',
  },
  {
    title: 'Giving USA 2022 - Data Tables',
    fileName: 'GivingUSA2022_DataTables.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GivingUSA2022_DataTables.pdf',
  },
  {
    title: 'Giving USA 2022 - Infographic',
    fileName: 'GivingUSA2022_Infographic.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GivingUSA2022_Infographic.pdf',
  },
  {
    title: 'Giving USA 2022 - Key Findings',
    fileName: 'GUSA 2022_Key Findings Product_Final.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA+2022_Key+Findings+Product_Final.pdf',
  },
  {
    title: 'Giving USA Special Report - Donor-Advised Funds: New Insights – Digital',
    fileName: 'Giving USA Special Report - Donor Advised Funds - New Insights - Download.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving+USA+Special+Report+-+Donor+Advised+Funds+-+New+Insights+-+Download.pdf',
  },
  {
    title: '2022 Annual Survey on State Laws - Subscriber Edition',
    fileName: 'GUSA_Annual_Survey_of_State_Giving Laws_2022.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA_Annual_Survey_of_State_Giving+Laws_2022.pdf',
  },
  {
    title: '2021 Annual Survey on State Laws',
    fileName: '2021 Annual Survey on State Laws',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving+USA+2021+Annual+Survey+on+State+Laws.pdf',
  },
  {
    title: '2021 Data Tables',
    fileName: 'GUSA2021_DataTables.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA2021_DataTables.pdf',
  },
  {
    title: '2021 Comprehensive Presentation PowerPoint',
    fileName: 'GUSA_2021_Full_PPT_Presentation_v4_6.17.21.pptx',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA_2021_Full_PPT_Presentation_v4_6.17.21.pptx',
  },
  {
    title: '2021 Key Findings',
    fileName: '2021 Key Findings',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA2021_KeyFindings.pdf',
  },
  {
    title: '2021 Library Rate',
    fileName: 'GUSA2021_LibraryRate_FULL 2.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA2021_LibraryRate_FULL+2.zip',
  },
  {
    title: '2021 Infographic',
    fileName: 'GUSA2021_Infographic.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA2021_Infographic.pdf',
  },
  {
    title: '2021 Annual Report - Subscriber Edition – Print+Digital',
    fileName: 'GUSA2021_AnnualReport_SubscriberEdition_FULL 2.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA2021_AnnualReport_SubscriberEdition_FULL+2.zip',
  },
  {
    title: '2021 Comprehensive Presentation PowerPoint - Subscriber Edition',
    fileName: 'GUSA_2021_Full_PPT_Presentation_v4_6.17.21.pptx',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA_2021_Full_PPT_Presentation_v4_6.17.21.pptx',
  },
  {
    title: 'One-Time Purchase – Print+Digital',
    fileName: 'GUSA2021_AnnualReport_ONE-TIME-PURCHASE_FULL 2.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA2021_AnnualReport_ONE-TIME-PURCHASE_FULL+2.zip',
  },
  {
    title: '2020 Annual Survey on State Laws',
    fileName: 'Spring 2020 Annual Survey of State Laws 3.10.20_FInal.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Spring+2020+Annual+Survey+of+State+Laws+3.10.20_FInal.pdf',
  },
  {
    title: 'Special 2020 Comprehensive Package',
    fileName: 'GUSA-2020-PACKAGE.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2020-PACKAGE.zip',
  },
  {
    title: '2020 Print Package',
    fileName: 'GUSA-2020-PRINTPACKAGE.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2020-PRINTPACKAGE.zip',
  },
  {
    title: '2020 Digital Package',
    fileName: 'GUSA-2020-PACKAGE.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2020-PACKAGE.zip',
  },
  {
    title: '2020 Key Findings',
    fileName: 'GUSA-2020-KEY-FINDINGS.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2020-KEY-FINDINGS.pdf',
  },
  {
    title: '2020 Comprehensive Presentation PowerPoint',
    fileName: 'GUSA-2020-COMPREHENSIVE-PRESENTATION-POWERPOINT.pptx',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2020-COMPREHENSIVE-PRESENTATION-POWERPOINT.pptx',
  },
  {
    title: '2020 Data Tables',
    fileName: 'GUSA-2020-DATA-TABLES.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2020-DATA-TABLES.pdf',
  },
  {
    title: '2020 Library Rate',
    fileName: 'GUSA-2020-LIBRARY-PACKAGE.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2020-LIBRARY-PACKAGE.zip',
  },
  {
    title: '2020 Infographic',
    fileName: 'GUSA-2020-INFOGRAPHIC.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2020-INFOGRAPHIC.zip',
  },
  {
    title: '2019 Annual Survey on State Laws',
    fileName: 'GUSA 2019 Annual Survey of State Laws.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA+2019+Annual+Survey+of+State+Laws.pdf',
  },
  {
    title: 'Special 2019 Comprehensive Package',
    fileName: 'GUSA-2019-Comprehensive-Package-DOWNLOAD-UPDATED.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2019-Comprehensive-Package-DOWNLOAD-UPDATED.zip',
  },
  {
    title: '2019 Print Package',
    fileName: 'GUSA-2019-Print-Package-DOWNLOAD-UPDATED.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2019-Print-Package-DOWNLOAD-UPDATED.zip',
  },
  {
    title: '2019 Digital Package',
    fileName: 'GUSA-2019-Digital-Package-UPDATEDDOWNLOAD.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2019-Digital-Package-UPDATEDDOWNLOAD.zip',
  },
  {
    title: '2019 Key Findings',
    fileName: 'GUSA-2019-Key-Findings-DOWNLOAD.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2019-Key-Findings-DOWNLOAD.pdf',
  },
  {
    title: '2019 Comprehensive PowerPoint',
    fileName: 'GUSA-2019-PowerPoint-UPDATED.pptx',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2019-PowerPoint-UPDATED.pptx',
  },
  {
    title: '2019 Data Tables',
    fileName: 'GUSA-2019-DATA-TABLES-DOWNLOAD.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2019-DATA-TABLES-DOWNLOAD.pdf',
  },
  {
    title: '2019 Library Rate',
    fileName: 'GUSA-2019-AnnualReport-DOWNLOAD-UPDATED.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2019-AnnualReport-DOWNLOAD-UPDATED.pdf',
  },
  {
    title: '2019 Infographic',
    fileName: 'GUSA-2019-Infographic-DOWNLOAD.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2019-Infographic-DOWNLOAD.zip',
  },
  {
    title: 'Leaving a Legacy: A New Look at Planned Giving Donors — Print Edition',
    fileName: 'GUSA-Special-Report-Fall-2019-Leaving-A-Legacy-download-NOV2019-Hi-Res.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-Special-Report-Fall-2019-Leaving-A-Legacy-download-NOV2019-Hi-Res.pdf',
  },
  {
    title: 'Leaving a Legacy: A New Look at Planned Giving Donors — Digital Edition',
    fileName: 'GUSA-Fall-2019-Special-Report-LeavingALegacy.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-Fall-2019-Special-Report-LeavingALegacy.pdf',
  },
  {
    title: 'Giving USA Special Report - The Data on Donor-Advised Funds – Digital Edition',
    fileName: 'Giving USA Special Report The Data on Donor Advised Funds Spring 2018 FINAL DIGITAL 2.27.18.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving+USA+Special+Report+The+Data+on+Donor+Advised+Funds+Spring+2018+FINAL+DIGITAL+2.27.18.pdf',
  },
  {
    title: 'Giving USA Special Report - The Data on Donor-Advised Funds – Print Edition',
    fileName: 'Giving USA Special Report The Data on Donor Advised Funds Spring 2018 FINAL DIGITAL 2.27.18.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving+USA+Special+Report+The+Data+on+Donor+Advised+Funds+Spring+2018+FINAL+DIGITAL+2.27.18.pdf',
  },
  {
    title: 'Giving USA: Annual Report on State Laws Regulating Charitable Solicitations as of January 1, 2018',
    fileName: 'GUSA Spring 2018 Annual Survey of State Laws 3.1.18.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA+Spring+2018+Annual+Survey+of+State+Laws+3.1.18.pdf',
  },
  {
    title: 'Library Rate for Annual Survey on State Laws Regulating Charitable Solicitations as of January 1, 2018',
    fileName: 'GUSA Spring 2018 Annual Survey of State Laws 3.1.18.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA+Spring+2018+Annual+Survey+of+State+Laws+3.1.18.pdf',
  },
  {
    title: 'Giving USA 2018: The Annual Report on Philanthropy for the Year 2017 Digital Package',
    fileName: 'Giving USA 2018 Paperback Package Download UPDATED.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving+USA+2018+Paperback+Package+Download+UPDATED.zip',
  },
  {
    title: 'Giving USA 2018: The Annual Report on Philanthropy for the Year 2017 Paperback Package',
    fileName: 'Giving USA 2018 Paperback Package Download UPDATED.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving+USA+2018+Paperback+Package+Download+UPDATED.zip',
  },
  {
    title: 'Giving USA 2018 Data Tables',
    fileName: 'GUSA 2018 Data Tables Download.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA+2018+Data+Tables+Download.pdf',
  },
  {
    title: 'Giving USA 2018 PowerPoint',
    fileName: 'GUSA 2018 PowerPoint Download.pptx',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA+2018+PowerPoint+Download.pptx',
  },
  {
    title: 'Giving USA 2018 Library Rate',
    fileName: 'GUSA 2018 Annual Report Library Rate Download.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA+2018+Annual+Report+Library+Rate+Download.pdf',
  },
  {
    title: 'Giving USA 2018 Report Highlights',
    fileName: 'GUSA-2018-Highlights-Download.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2018-Highlights-Download.pdf',
  },
  {
    title: 'Giving USA Special Report - The Evolution of Workplace Giving – Digital Edition',
    fileName: 'GUSA Special Report on Workplace Giving.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-SpecialReport-2018-WorkplaceGiving.pdf',
  },
  {
    title: 'Giving USA: Annual Report on State Laws Regulating Charitable Solicitations as of January 1, 2017',
    fileName: 'GivingUSA-Annual-Laws-2017.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GivingUSA-Annual-Laws-2017.pdf',
  },
  {
    title: 'Giving USA 2017: The Annual Report on Philanthropy for the Year 2016 Paperback Book Package',
    fileName: 'Giving-USA-Paperback_Package_Download.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-Paperback_Package_Download.zip',
  },
  {
    title: 'Giving USA 2017: The Annual Report on Philanthropy for the Year 2016 Digital Package',
    fileName: 'Giving-USA-Digital_Package_Download.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-Digital_Package_Download.zip',
  },
  {
    title: 'Library Rate for Giving USA 2017: The Annual Report on Philanthropy for the Year 2016',
    fileName: 'GUSA-2017-Report-Download.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2017-Report-Download.pdf',
  },
  {
    title: 'Giving USA 2017 PowerPoint: An easy-to-use presentation of report findings including talking points',
    fileName: 'Giving-USA-2017-PowerPointDownload.pptx',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-2017-PowerPointDownload.pptx',
  },
  {
    title: 'Giving USA 2017 Data Tables',
    fileName: 'Giving-USA-2017-DataTables.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-2017-DataTables.pdf',
  },
  {
    title: 'Library Rate for Annual Survey on State Laws Regulating Charitable Solicitations as of January 1, 2017',
    fileName: 'GivingUSA-Annual-Laws-2017.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GivingUSA-Annual-Laws-2017.pdf',
  },
  {
    title: 'Giving USA 2017 Report Highlights',
    fileName: 'GUSA-2017-Highlights-Download.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-2017-Highlights-Download.pdf',
  },
  {
    title: 'Giving USA Special Report – Giving To Religion – Digital Edition',
    fileName: 'GUSA_GivingToReligion_Fall2017.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA_GivingToReligion_Fall2017.pdf',
  },
  {
    title: 'Giving USA 2017: The Annual Report on Philanthropy for the Year 2016 – Digital',
    fileName: 'Giving-USA-Digital_Package_Download.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-Digital_Package_Download.zip',
  },
  {
    title: 'Giving USA Special Report – Giving To Religion – Subscriber Edition – Print+Digital',
    fileName: 'GUSA_GivingToReligion_Fall2017.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA_GivingToReligion_Fall2017.pdf',
  },
  {
    title: 'Giving USA 2017: The Annual Report on Philanthropy for the Year 2016 - Subscriber Edition – Digital',
    fileName: 'Giving-USA-Digital_Package_Download.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-Digital_Package_Download.zip',
  },
  {
    title: 'Giving USA 2016: The Annual Report on Philanthropy for the Year 2015 Paperback Book Package',
    fileName: 'GivingUSA_2016_Downloads_Package.zip',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GivingUSA_2016_Downloads_Package.zip',
  },
  {
    title: 'Giving USA Special Report - Giving and the Golden Years - Print Edition',
    fileName: 'GUSA-Special-Report-Giving-And-The-Golden-Years-Digital.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/GUSA-Special-Report-Giving-And-The-Golden-Years-Digital.pdf',
  },
  {
    title: 'Giving USA 2016 PowerPoint: An easy-to-use presentation of report findings including talking points',
    fileName: 'Giving-USA-2016-Powerpoint-Final.pptx',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-2016-Powerpoint-Final.pptx',
  },
  {
    title: 'Giving USA 2016 Data Tables',
    fileName: 'Giving-USA-2016-Data-Tables.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-2016-Data-Tables.pdf',
  },
  {
    title: 'Giving USA 2016 Report Highlights',
    fileName: 'Giving-USA-2016-Highlights.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-2016-Highlights.pdf',
  },
  {
    title: 'Giving USA Philanthropy Spotlight: Benchmarking Giving to Human Services',
    fileName: 'Giving-USA-Spotlight-Human-Services.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-Spotlight-Human-Services.pdf',
  },
  {
    title: 'Library Rate for Giving USA 2016: The Annual Report on Philanthropy for the Year 2015s',
    fileName: 'Giving-USA-2016-Annual-Report-Digital.pdf',
    fileUrl: 'https://gusa-bucket.s3.amazonaws.com/Giving-USA-2016-Annual-Report-Digital.pdf',
  },
];

  function get_download(fileindex) {
  
  	let anchor = document.createElement("a");
	anchor.href = Downloadlist[fileindex].fileUrl;
	anchor.download = Downloadlist[fileindex].fileName;
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
  
  }